// Unpublished Work © 2021-2022 Deere & Company

const themeClassNameMap = new Map();

export const availableThemes = {
    AGRICULTURE_TURF: 'AG_TURF',
    CONSTRUCTION_FORESTRY: 'CONSTRUCTION_FORESTRY',
    HITACHI: 'HITACHI'
};

themeClassNameMap.set(availableThemes.AGRICULTURE_TURF, 'agriculture-turf');
themeClassNameMap.set(availableThemes.CONSTRUCTION_FORESTRY, 'construction-forestry');
themeClassNameMap.set(availableThemes.HITACHI, 'hitachi');

export const AppThemes = themeClassNameMap;
